import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './AddDriverButtons.css';
import Button from '../../components/UI/Button/Button';


class AddNewDriverButtons extends Component {
    render () {        
        return (
            <div className={classes.AddDriverButtons}>
                
                <Button 
                    btnType="Success"
                    clicked={this.props.onAddDriver}>ADD DRIVER</Button>
                                
            </div>
        );
    }
};

export default ( AddNewDriverButtons);


// WEBPACK FOOTER //
// ./src/components/DriverButtons/AddNewDriverButtons.js